import React from 'react'
import {
	Container,
	LeadFormVerticalDeskPreloader,
	maxWidthCotnainer,
} from '@rst/ui-ts'
import { media } from '@rst/libs-ts'
import styled from 'styled-components'

export const LeadFormVerticalDesk = ({ data }: any) => {
	return (
		<StyledContainer align={data.align}>
			<LeadFormVerticalDeskPreloader {...data} />
		</StyledContainer>
	)
}

const StyledContainer = styled(Container)<{ align: string }>`
	padding: 56px 0;
	${media.pure.less(1128)} {
		padding: 56px 34px !important;
	}
	display: flex;
	justify-content: center;
	max-width: ${p =>
		p.align === 'left' || 'right' ? maxWidthCotnainer(p) : 'unset'};
	flex-direction: ${p => (p.align === 'left' ? 'row-reverse' : 'row')};
`
